import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { EditStaffModalComponent } from '../../staff/edit-staff-modal/edit-staff-modal.component'
// import { AddStaffModalComponent } from '../../staff/add-staff-modal/add-staff-modal.component'
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { UtilityService } from '../../services/utility.service'
import { AccidentService } from '../../services/accident.service'
import { AccidentUserService } from '../../services/accident-user.service';
import * as _ from 'lodash';
import { identifierName } from '@angular/compiler';
import { accidentUserRoles, reporterForm } from '../../_models/staticArray'


declare var $;

@Component({
  selector: 'app-add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styleUrls: ['./add-user-modal.component.scss']
})
export class AddUserModalComponent implements OnInit {
  loading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public _accidentUser: AccidentService,
    public dialogRef: MatDialogRef<any>,
    public _EncryptDecryptService: EncryptDecryptService,
    private _utility: UtilityService,
    public _accidentUserService: AccidentUserService
  ) { }
  addUserAccident: FormGroup;
  isEmailError: boolean
  show: boolean;
  pwd: boolean;
  show1: boolean;
  pwd1: boolean;
  passwordMismatch
  match
  tempUser
  user
  modelTitle
  accidentUser: boolean
  accidentRole = accidentUserRoles;
  // [  { key: 'Witness', value: 'witness' }, { key: 'Reporters', value: 'reporter' }, { key: 'Investigation Officer', value: 'officer' }]

  reporterForm = reporterForm;
  //  [
  //   {
  //     key: 'Environmental Incident Reporting Form',
  //     value: 'envForm'
  //   },
  //   {
  //     key: 'Incident Reporting Form',
  //     value: 'irForm'
  //   },
  // ]
  // accidentRole:accidentRole
  // data = {}
  currentRole
  userList = [];
  error
  userRole
  selectedRole
  isDisable: boolean = false
  isUserRole: boolean = false




  ngOnInit() {

    this.loading = false;
    this.isEmailError = true
    this.userRole = JSON.parse(localStorage.getItem('userRoles'))
    console.log("this.userRole", this.userRole);

    if (!this.userRole.isAdmin || !this.userRole.isManager) {
      this.accidentRole = [
        { key: 'Witness', value: 'witness' }]
    }

    console.log("data", this.data);
    if (this.data && this.data.accidentType == 'goodPractice') {
      this.selectedRole = 'reporter'
      this.accidentRole = [
        { key: 'Reporters', value: 'reporter' }]
      // this.isDisable = true
    }
    $(".passwords").click(function () {
      console.log("password toggle");
      $(".passwords").toggleClass("fa-eye fa-eye-slash");
    });

    $(".cpasswords").click(function () {
      console.log("cpassword toggle");
      $(".cpasswords").toggleClass("fa-eye fa-eye-slash");
    });
    console.log("data value-------->", this.data);
    if (this.data && this.data.edit == true) {
      console.log("data value-------->", this.data.userId);
      this.modelTitle = 'Edit User'
      let data = {
        name: this.data.userId.name,
        email: this.data.userId.email,
        password: this._EncryptDecryptService.decrypt(this.data.userId.password),
        confirmPassword: this._EncryptDecryptService.decrypt(this.data.userId.password),
        role: this.data.userId.systemRole,
        userRole: this.data.userId.userRole,
        userId: this.data.userId.userId,
        userForm: this.data.userId.userForm
      }
      console.log("data value-------->", this.data);
      if (this.data && this.data.userId.systemRole && (this.data.userId.systemRole.includes('trainer') || this.data.userId.systemRole.includes('IQA') || this.data.userId.systemRole.includes('mp') || this.data.userId.systemRole.includes('operative') || this.data.userId.systemRole.includes('learner'))) {

        if (this.data && (this.data.accidentType == 'goodPractice')) {
          this.isUserRole = true

        } else {
          this.isUserRole = false
        }

        this.isDisable = true
      } else {
        this.isUserRole = false
        this.isDisable = false
      }
      console.log("data -------->", data);
      this.createForm(data)
    } else {
      this.modelTitle = 'Add User'
      if (this.data && this.data.accidentUser)
        this.accidentUser = true
      else
        this.accidentUser = false
      this.createForm()
    }
  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }


  /**
   * form Group intilize
   */
  createForm(data?) {

    console.log("data--->", data);
    console.log("this.accidentUser--->", this.accidentUser);
    this.addUserAccident = new FormGroup({
      name: new FormControl((data && data.name) ? data.name : ' '),
      email: new FormControl((data && data.email) ? data.email : '', Validators.required),
      password: new FormControl((data && data.password) ? data.password : '', [Validators.required]),
      confirmPassword: new FormControl((data && data.confirmPassword) ? data.confirmPassword : '', [Validators.required]),
      role: new FormControl((data && data.role) ? data.role : ''),
      userRole: new FormControl((data && data.userRole) ? data.userRole : this.selectedRole ? this.selectedRole : '', Validators.required),
      userId: new FormControl((data && data.userId) ? data.userId : ''),
      userForm: new FormControl((data && data.userForm) ? data.userForm : ''),
      // userForm: new FormControl(''),
      mobile: new FormControl((data && data.mobile) ? data.mobile : ''),
    })
    if (this.accidentUser) {
      this.addUserAccident.get('name').enable()
      this.addUserAccident.get('password').enable()
      this.addUserAccident.get('confirmPassword').enable()
      this.addUserAccident.get('role').enable()
    } else {
      this.addUserAccident.get('name').disable()
      this.addUserAccident.get('password').disable()
      this.addUserAccident.get('confirmPassword').disable()
      this.addUserAccident.get('role').disable()
    }
    if (data) {
      if (data && data.role && data.role != 'incidentUser') {
        this.addUserAccident.get('name').disable()
        this.addUserAccident.get('password').disable()
        this.addUserAccident.get('confirmPassword').disable()
        this.addUserAccident.get('role').disable()
      }
      else {
        this.addUserAccident.get('name').enable()
        this.addUserAccident.get('password').enable()
        this.addUserAccident.get('confirmPassword').enable()
        this.addUserAccident.get('role').disable()
      }
    }


  }

  findUsers(value) {
    this.isEmailError = true
    console.log('..hello data email find function work !!!', value)
    let obj = {
      email: value,
      accidentId: this.data.accidentId
    }
    this._accidentUser.getAccidentUser(obj).subscribe((data) => {
      console.log('get users response here .....', data)
      this.userList = data.foundUsers;
    }, (error) => {
      console.log('some error occure when get users list', error)
    })
  }


  comparePassword(form) {
    console.log(form.value.password == form.value.confirmPassword, this.match);
    if (form.value.password === form.value.confirmPassword) {
      console.log("In true condition");
      this.match = true;
      this.passwordMismatch = false
    } else {
      this.match = false;
      this.passwordMismatch = true
    }

  }
  closeDialog() {
    this._utility.closeDialog(this.dialogRef)
  }

  /**
   * selectusers
   */
  selectUsers(user) {
    console.log("what is user data", user);
    let element = this.userList.find((x) => x._id == user._id)
    console.log("find element data", element);
    this.isEmailError = false
    this.tempUser = element;

    // if (element != undefined) {
    //   this.createForm(element)
    // }
    // else{ 
    if (element.userRole.length) {
      var role1 = element.userRole.indexOf("mp");
      var role2 = element.userRole.indexOf("incidentUser");
      // var role3 = element.userRole.indexOf("mp");

      if (role1 !== -1) {
        element.userRole[role1] = "Medical Pratitioner";
      }
      if (role2 !== -1) {
        element.userRole[role2] = "Incident User";
      }

      for (var i = 0; i < element.userRole.length; i++) {
        // element.userRole[i] = element.userRole[i].charAt(0).toUpperCase();
        element.userRole[i] = element.userRole[i].charAt(0).toUpperCase() + element.userRole[i].substr(1);
        console.log("user Role Capitalze !!!!!!!!!!!!!", element.userRole[i])
      }
      // this.isDisable = true
      // console.log("add user role Formate........")
    }

    this.addUserAccident.patchValue({
      email: element.email,
      name: element.user.name,
      password: this._EncryptDecryptService.decrypt(element.password),
      confirmPassword: this._EncryptDecryptService.decrypt(element.password),
      role: element.userRole.join(','),
      userId: element._id
    })
    // }
    this.userList = []
  }


  addUser() {
    this.loading = true

    if (this.data && this.data.accidentUser) {
      const data = new FormData();
      _.forOwn(this.addUserAccident.value, (value, key) => {
        console.log("this is value ", value);
        if (key == 'convictionList') {
          data.append(key, JSON.stringify(value))
        } else if (key == 'password') {
          console.log('this is key', key);
          const newPass = this._EncryptDecryptService.encrypt(value)
          data.append(key, newPass)
        } else if (key == 'role') {
          // let roleArray: any = []
          // roleArray.push(value.map((x) => { return x }))
          data.append(key, JSON.stringify(value))
        }
        else if (key == 'license') {
          data.append(key, JSON.stringify(value))
        }
        else {
          data.append(key, value)
        }
      });
      data.append('userId', this.addUserAccident.value.userId)
      data.append('accidentId', this.addUserAccident.value.accidentId)
      data.append('onModel', 'accidentUser')
    }
    if (this.data && this.data.edit) {
      const data = new FormData();
      _.forOwn(this.addUserAccident.value, (value, key) => {
        console.log("this is value ", value);

        if (key == 'role') {
          data.append(key, JSON.stringify(value))
        } else {
          data.append(key, value)
        }

      });
      data.append('_id', this.data.userId._id)
      data.append('onModel', this.data.userId.onModel)
      data.append('accidentId', this.data.accidentId)
      console.log("this is for edit data", data);

      this._accidentUserService.editAccidentUser(data).subscribe((response) => {
        console.log("edit user response", response);
        this._utility.closeDialog(this.dialogRef, response)
      }, error => {
        console.log("Error", error);

      })


    } else {
      if (this.addUserAccident.valid && !this.accidentUser) {
        console.log('check data here .... add user model', this.addUserAccident.value)
        let newPassword = this._EncryptDecryptService.encrypt(this.addUserAccident.value.password)
        let accidentUser = {
          userId: this.addUserAccident.controls['userId'].value,
          userRole: this.addUserAccident.controls['userRole'].value,
          accidentId: this.data.accidentId,
          userForm: this.addUserAccident.controls['userForm'].value,
          // password: newPassword,
          // role: this.addUserAccident.controls['role'].value
        }
        this._accidentUser.addExistingUserInAccident(accidentUser).subscribe((res) => {
          console.log("res of add multiple user", res);
          this.tempUser['status'] = res.status
          this.tempUser['userForm'] = res.userForm
          this.tempUser['userRole'] = res.userRole;
          this.tempUser['userId'] = this.addUserAccident.controls['userId'].value
          this.tempUser['accidentId'] = this.data.accidentId
          this.tempUser['name'] = this.tempUser.user.name
          this.tempUser['redirectUrl'] = res.redirectUrl
          this.tempUser['queryParams'] = res.queryParams
          this.tempUser['formName'] = res.formName
          this._utility.closeDialog(this.dialogRef, this.tempUser)
        }, error => {
          this.loading = false
          console.log("error while add user", error);
          if (error && error.status == 400) {
            this.error = error.msg
          }
        })
      } else if (this.addUserAccident.valid && this.accidentUser) {
        this.loading = true
        const data = new FormData();
        _.forOwn(this.addUserAccident.value, (value, key) => {
          console.log("this is value ", value);
          if (key == 'password') {
            console.log('this is key', key);
            const newPass = this._EncryptDecryptService.encrypt(value)
            data.append(key, newPass)
          } else if (key == 'role') {
            data.append(key, JSON.stringify(value))
          } else {
            data.append(key, value)
          }
        });
        data.append('accidentId', this.data.accidentId)
        console.log('data value---- !!!', data)
        // this.addUserAccident['accidentId'] = this.data.accidentId
        this._accidentUserService.addAccidentUser(data).subscribe((accidentUser) => {
          console.log('accident users data response here =>', accidentUser)
          accidentUser['email'] = this.addUserAccident.value.email
          accidentUser['mobile'] = this.addUserAccident.value.mobile
          accidentUser['password'] = this._EncryptDecryptService.encrypt(this.addUserAccident.value.password),
            accidentUser['formName'] = accidentUser.userForm

          console.log('accident users data here =>', accidentUser)
          this.loading = false
          this._utility.closeDialog(this.dialogRef, accidentUser)
        }, (error) => {
          this.loading = false
          console.log('some thing wrong !!!', error)
          this.error = error.msg
        })
      } else {
        console.log("add accident form value", this.addUserAccident);

        this.addUserAccident.markAllAsTouched();

        this.loading = false
        this.error = "All fields are required"
      }
    }
  }



  /**
   * staff model open for accident ...........
   */


  openStaffModel() {
    console.log("this.data", this.data);
    this.accidentUser = true
    let data1 = {}
    data1['accidentUser'] = true;
    data1['accidentId'] = this.data.accidentId
    data1['accidentType'] = this.data.accidentType
    console.log('this.accident staff model open here......')
    let array = []
    array.push(data1)
    $("#password").click(function () {
      console.log("password toggle");
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      console.log("cpassword toggle");
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });

    const dialogRef = this._utility.commonDialogBoxOpen(AddUserModalComponent, data1)
      .afterClosed().subscribe((data) => {
        // console.log("this.data1-->", data1);
        console.log('model subscribe get data display here', data)
        this._utility.closeDialog(this.dialogRef, data)
      }, (error) => {
        console.log('model addstaff component open time some error occure', error)

      })
  }

}
